// app.jsx
import React, { useState, useEffect } from "react";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import HackerMessage from "./components/hacker-message";
import CreatieMessage from "./components/creatie-message";
import Cookies from 'js-cookie';
import './styles/global.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showDevMessage, setShowDevMessage] = useState(false);
  const [showCreatieMessage, setShowCreatieMessage] = useState(false);

  useEffect(() => {
    const pathDevChallenge = window.location.pathname.includes('AI-challenge-development');
    const pathCreatieChallenge = window.location.pathname.includes('AI-challenge-creatie');
    const urlParams = new URLSearchParams(window.location.search);
    const aiDevChallenge = urlParams.get('AI-challenge-development');
    
    if (pathDevChallenge || aiDevChallenge) {
      setIsLoggedIn(true);
      const timer = setTimeout(() => setShowDevMessage(true), 500);
      return () => clearTimeout(timer);
    }
    
    if (pathCreatieChallenge) {
      setIsLoggedIn(true);
      const timer = setTimeout(() => setShowCreatieMessage(true), 500);
      return () => clearTimeout(timer);
    }

    const loginStatus = Cookies.get('isLoggedIn');
    if (loginStatus === 'true') {
      setIsLoggedIn(true);
    }
  }, []);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  return (
    <div className="App">
      {!isLoggedIn ? (
        <Login onLoginSuccess={handleLoginSuccess} />
      ) : (
        <>
          <Dashboard />
          {showDevMessage && (
            <HackerMessage 
              isOpen={showDevMessage}
              onClose={() => setShowDevMessage(false)}
              message={`> initializing...
> system booting...
> welcome to Unframed AI
            
De code is geschreven. De toekomst is hier.
            
Welkom op Unframed AI, dé plek waar je diep in de wereld van AI duikt. Hier vind je alles wat je nodig hebt: relevante kennis, hands-on how-to's en inspirerende demo's om AI naar jouw hand te zetten. Of je nu wilt leren of je ervaring wilt delen — jij bepaalt de koers.
            
Heads-up! Op 30 januari word jij onderdeel van een epische AI-challenge. Je skills, kennis en probleemoplossend vermogen worden getest. Details volgen… maar onthoud: voorbereiding is alles.
            
> stay sharp. stay curious.
> end of transmission.
            
Groeten,
Unframed AI`}
            />
          )}
          {showCreatieMessage && (
            <CreatieMessage 
              isOpen={showCreatieMessage}
              onClose={() => setShowCreatieMessage(false)}
              message={`[Systeem opgestart]
[Creatieve modus geactiveerd]

Beste creator,

Welkom in het lab waar verbeelding en technologie samensmelten. Hier creëren we niet alleen content—we scheppen nieuwe realiteiten.

Op 22 februari dagen we je creativiteit uit tijdens de eerste Unframed AI Creative Challenge. Bereid je voor op een dag waar jouw artistieke visie en AI-tools samen magie maken.

Wat kun je verwachten?
- Inzichten en ervaringen met cutting-edge AI 
- Experimenteren met nieuwe vormen van contentcreatie
- Je werk presenteren aan een publiek van innovators

[Creativiteit gedetecteerd]
[Systeem klaar voor input]

Tot 22 februari,

Unframed AI`}
            />
          )}
        </>
      )}
    </div>
  );
}

export default App;